(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('NotificationTrackerStatusService', NotificationTrackerStatusService);

  NotificationTrackerStatusService.$inject = ['$resource'];

  function NotificationTrackerStatusService ($resource) {
    return $resource(apiUrl + '/notification-tracker/:id', { id: '@id' }, {
      update: { method: 'PUT' },
      all: { method: 'GET', isArray: true },
      remove: { method: 'DELETE', isArray: false },
      getSendingChannels: { url: apiUrl + '/notification-tracker/sending-channels', method: 'GET', params: {}, isArray: true }
    });
  }
})();
